import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { Text, ThemeTextColorPath } from 'platform/foundation-tw';
import { isNotNil } from 'ramda-adjunct';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getStylesToRender } from '../../utils/getStylesToRender';
import { getTooltipProps } from '../../utils/getTooltipProps';
type TimeIntervalCellRendererProps = CellRendererProps<number | null> & {
  getTooltipProps?: TooltipGetter;
};
type CellStyle = {
  textColor?: ThemeTextColorPath;
};
export function TimeIntervalCellRenderer(props) {
  const $ = _c(19);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  let t1;
  if ($[2] !== props) {
    t1 = getStylesToRender(props);
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cellStyles = t1 as CellStyle | undefined;
  let t2;
  if ($[4] !== props.getTooltipProps || $[5] !== props.row) {
    t2 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[4] = props.getTooltipProps;
    $[5] = props.row;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const tooltipProps = t2;
  let t3;
  if ($[7] !== props.value) {
    t3 = isNotNil(props.value) ? String(props.value) : "";
    $[7] = props.value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const cellValue = t3;
  const t4 = cellStyles?.textColor;
  const t5 = !props.column?.wrapText;
  let t6;
  if ($[9] !== cellValue || $[10] !== t4 || $[11] !== t5) {
    t6 = <Text color={t4} noWrap={t5} size="small">{cellValue}</Text>;
    $[9] = cellValue;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== t6) {
    t7 = <div className={className}>{t6}</div>;
    $[13] = className;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7 || $[17] !== tooltipProps) {
    t8 = <Tooltip {...tooltipProps}>{t7}</Tooltip>;
    $[16] = t7;
    $[17] = tooltipProps;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}